import { Container, Graphics, Application } from 'pixi.js';

interface ImpactRing {
    x: number;
    y: number;
    radius: number;
    maxRadius: number;
    alpha: number;
    life: number;
    maxLife: number;
    color: number;
}

export default class ImpactEffect {
    private app: Application;
    private gameWorld: Container;
    private rings: ImpactRing[] = [];
    private graphics: Graphics;
    private maxRings: number = 5;

    constructor(app: Application, gameWorld: Container) {
        this.app = app;
        this.gameWorld = gameWorld;
        this.graphics = new Graphics();
        this.gameWorld.addChild(this.graphics);
    }

    public createImpact(x: number, y: number, intensity: number = 1, color: number = 0xFFFFFF): void {
        // Remove oldest ring if at capacity
        if (this.rings.length >= this.maxRings) {
            this.rings.shift();
        }

        const maxRadius = 30 + intensity * 40;
        const life = 400 + intensity * 200;

        this.rings.push({
            x,
            y,
            radius: 5,
            maxRadius,
            alpha: 0.8,
            life: life,
            maxLife: life,
            color
        });
    }

    public update(delta: number): void {
        this.graphics.clear();

        for (let i = this.rings.length - 1; i >= 0; i--) {
            const ring = this.rings[i];
            
            // Update ring properties
            const progress = 1 - (ring.life / ring.maxLife);
            ring.radius = 5 + (ring.maxRadius - 5) * progress;
            ring.alpha = 0.8 * (1 - progress * progress); // Fade out faster

            // Draw ring
            this.graphics.circle(ring.x, ring.y, ring.radius);
            this.graphics.stroke({ 
                width: 3, 
                color: ring.color, 
                alpha: ring.alpha 
            });

            // Draw inner glow
            this.graphics.circle(ring.x, ring.y, ring.radius * 0.6);
            this.graphics.stroke({ 
                width: 2, 
                color: ring.color, 
                alpha: ring.alpha * 0.5 
            });

            ring.life -= delta * 60; // Convert delta to ms

            if (ring.life <= 0) {
                this.rings.splice(i, 1);
            }
        }
    }
}

